import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import EProcurementsComponent from '../components/e-procurements.component';
import { selectEProcurementsQueryItems } from '../../../../../redux/e-procurements/selector';
import { eProcurements } from '../../../../../redux/e-procurements/action';

const ManagementEProcurementsSettings = () => {
  const dispatch = useAppDispatch()
  const eProcurementsSettingsQuery = useSelector(selectEProcurementsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectEProcurementSettings, setSelectEProcurementSettings] = useState<any>([])

  const fetchEProcurementsSettingsQueryById = () => {
    dispatch(eProcurements.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/e-procurements/query`,
      entity: 'eProcurements',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectEProcurementSettings({ ...selectEProcurementSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchEProcurementsSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectEProcurementSettings(eProcurementsSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(eProcurements.resetAction({ actionType: 'update' }))
    await dispatch(eProcurements.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/e-procurements`,
      entity: 'eProcurements',
      jsonData: {
        Records: [
          selectEProcurementSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <EProcurementsComponent
          handleInnerFormChange={handleInnerFormChange}
          selectEProcurementSettings={selectEProcurementSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementEProcurementsSettings;